import { PanelLeft } from "lucide-react";
import { type JSX } from "react";
import { cn } from "./lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

export interface CollapseHandleProps {
  collapsed: boolean;
  onToggle: () => void;
  className?: string;
}

export interface CollapseHandleIconProps {
  collapsed: boolean;
  className?: string;
}

export function CollapseHandleIcon({ collapsed, className }: CollapseHandleIconProps): JSX.Element {
  return <PanelLeft className={cn("size-3.5", collapsed && "rotate-180", className)} strokeWidth={1.75} />;
}

/** Small handle pinned to the sidebar's right edge that toggles the icon rail. */
export function CollapseHandle({ collapsed, onToggle, className }: CollapseHandleProps): JSX.Element {
  const label = collapsed ? "Expand navigation" : "Collapse navigation";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={!collapsed}
          aria-label={label}
          data-platform-sidebar-toggle=""
          className={cn(
            "flex h-14 w-4 items-center justify-center rounded-sm",
            // The handle floats in the gutter between the sidebar and the content
            // panel; the token-backed nav surface keeps it legible without adding
            // a separate border or shadow treatment.
            "bg-shell-neutral text-shell-neutral-text transition-colors hover:bg-shell-neutral-hover hover:text-sidebar-text",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
            "focus-visible:ring-offset-2 focus-visible:ring-offset-shell-canvas",
            className
          )}
        >
          <CollapseHandleIcon collapsed={collapsed} />
        </button>
      </TooltipTrigger>
      <TooltipContent side="right">{label}</TooltipContent>
    </Tooltip>
  );
}
